export default __webpack_public_path__ + "static/media/lustrous_stone_from_guyun.ca152002.png";